import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface RescheduleTrialBookingParams {
  trialId: string;
  startTime: string;
  endTime: string;
  notes?: string;
}

export const rescheduleTrialBooking = async ({
  trialId,
  ...body
}: RescheduleTrialBookingParams) => {
  const response = await baseAPI.patch<unknown>(
    `trialstudents/${trialId}/reschedule`,
    body,
  );
  return response.data;
};

export const useRescheduleTrialBooking = () => {
  return useMutation({
    mutationFn: (params: RescheduleTrialBookingParams) =>
      rescheduleTrialBooking(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRIAL_STUDENTS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRIAL_LIFECYCLE_CONFLICTS],
      });
    },
  });
};
